const TOKEN_KEY = 'cw_admin_token'
const NICKNAME_KEY = 'cw_admin_nickname'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(NICKNAME_KEY)
}

export function getAdminNickname() {
  return localStorage.getItem(NICKNAME_KEY) || '运营管理员'
}

export function setAdminNickname(name) {
  localStorage.setItem(NICKNAME_KEY, name || '')
}
